import React from "react";

export class FAQ extends React.Component {

    state = {
        expandedFaqSectionIndex: -1
    };

    toggleFaqCollapsedState = (index) => {
        this.setState({
            expandedFaqSectionIndex: (index===this.state.expandedFaqSectionIndex)? -1 : index
        });
    };

    handleKeyDown = (event, index) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.toggleFaqCollapsedState(index);
        }
    };

    displayFaqContent = (content) => {
        return <div style={{ paddingLeft: '2.2em' }}>
            {
                content.map((item, index) => <div key={index}>
                    <h4 style={{ marginTop: '1em' }} className="headline-small">{item.question}</h4>
                    <p className="journey-steps">{item.description}</p>
                </div>)
            }
        </div>;
    };

    render() {
        const data = this.props.data;

        return <div>
            {
                data.map((faqItem, index) => {
                    const isExpanded = index === this.state.expandedFaqSectionIndex;

                    return <div style={{ paddingTop: '1rem', paddingRight: '0.6rem' }} key={index}>
                        <button
                            type="button"
                            aria-expanded={isExpanded}
                            className="faq-section-button d-flex flex-row align-items-center small-progressbar font-weight-light"
                            onClick={() => this.toggleFaqCollapsedState(index)}
                            onKeyDown={(e) => this.handleKeyDown(e, index)}
                        >
                            <i className="material-icons blue-text" aria-hidden="true">
                                {isExpanded ? 'remove' : 'add'}
                            </i>
                            {faqItem.title}
                        </button>
                        {isExpanded ? this.displayFaqContent(faqItem.content) : <div />}
                        <hr/>
                    </div>;
                })
            }
        </div>;
    }
}

export default FAQ;